export default __webpack_public_path__ + "static/media/instagram.1c3e2181.svg";